import HireTalentLayout from "../../layouts/HireTalentLayout";
import { getProfile, setProfile } from "../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { hireTalentPaths } from "../../routes/hire-talent";
import { fetchHireTalentProfile } from "../../redux/features/hire-talent/actions/authAction";
import { normalizeHireTalentProfile } from "../../utils/hireTalentProfile";
import Loader from "../../components/loader";

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.hireTalent?.auth);
  const [profile, setProfileState] = useState(() => getProfile("hire-talent") || {});

  const companyName = profile?.company_name || "Company Name";
  const industry = profile?.industry || "Industry";
  const location = [profile?.city, profile?.country].filter(Boolean).join(", ") || "N/A";
  const companySize = profile?.company_size || profile?.number_of_employees || "Employees";

  useEffect(() => {
    dispatch(fetchHireTalentProfile()).then((res) => {
      const data = res?.payload?.data;
      if (data) {
        const normalized = normalizeHireTalentProfile({
          ...data,
          ...(data.hiretalent || {}),
        });
        setProfile("hire-talent", normalized);
        setProfileState(normalized);
      }
    });
  }, [dispatch]);
  const companyDescription = profile?.company_description || profile?.company_bio || "";
  const linkedinCompany = profile?.linkedin_company || profile?.linkedin_company_page || "N/A";
  const primaryContactPhone =
    profile?.primary_contact_phone || profile?.primary_contact_phone_number || "N/A";
  const primaryContactName =
    profile?.primary_contact_name || profile?.primary_contact_full_name || "N/A";
  const primaryContactTitle =
    profile?.primary_contact_title || profile?.primary_contact_job_title || "N/A";
  const primaryContactEmail =
    profile?.primary_contact_email || profile?.primary_contact_work_email || "N/A";
  const secondaryContactName =
    profile?.secondary_contact_name || profile?.secondary_contact_full_name || "N/A";
  const secondaryContactTitle =
    profile?.secondary_contact_title || profile?.secondary_contact_job_title || "N/A";
  const secondaryContactEmail =
    profile?.secondary_contact_email || profile?.secondary_contact_work_email || "N/A";
  const secondaryContactPhone =
    profile?.secondary_contact_phone || profile?.secondary_contact_phone_number || "N/A";
  const talentTypes = profile?.talent_types?.length ? profile.talent_types : [];
  const engagementTypes =
    profile?.engagement_types?.length ? profile.engagement_types : [];
  const communicationTools =
    profile?.communication_tools?.length ? profile.communication_tools : [];
  const workEnvironment = profile?.work_environment || "N/A";

  return (
    <HireTalentLayout>
      {subLoading && <Loader />}
      <div className="ct_px_40 my-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-6 mb-4 mb-xl-0">
              <div className="ct_outline_bg ct_border_radius_10 ct_p_20">
                <div className="d-flex align-items-center gap-3 ct_flex_col_575 ">
                  <div className="ct_profile_pic ct_flex_shrink_0">
                    <img
                      src={profile?.profile_image || "../assets/img/user_dummy_imag.avif"}
                      alt="Company"
                    />
                  </div>
                  <div className="ct_flex_1">
                    <div className="d-flex align-items-center gap-3 justify-content-between mb-3 ">
                      <div>
                        <h4 className="ct_fs_20 ct_darkblue_text mb-2">{companyName}</h4>
                        <p className="ct_fs_14 ct_darkblue_text mb-0">
                          {industry} | {profile?.country || "Country"}
                        </p>
                      </div>
                      <div>
                        <button
                          className="ct_yellow_btn ct_sky_blue_btn ct_h_32 ct_white_nowrap"
                          type="button"
                          onClick={() => navigate(hireTalentPaths.EditProfile)}
                        >
                          Edit Profile
                        </button>
                      </div>
                    </div>
                    <p className="ct_para_scroll ct_custom_scroll ct_grey_text">
                      {companyDescription}
                    </p>
                    <ul>
                      <li className="d-flex align-items-center gap-2">
                        <img src="../assets/img/grey_mail_icon.svg" />
                        {profile?.email || "N/A"}
                      </li>
                      <li className="d-flex align-items-center gap-2 mt-1">
                        <img src="../assets/img/grey_phon_icon.svg" />
                        {primaryContactPhone}
                      </li>
                      <li className="d-flex align-items-center gap-2 mt-1">
                        <i className="fa-solid fa-location-dot"></i> {location}
                      </li>
                    </ul>
                  </div>
                </div>

                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_40">
                  {/* <li>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-star ct_text_yellow"></i>
                      <div>
                        <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                          {profile?.rating || "4.7"} Rating
                        </h4>
                        <p className="ct_fs_14 ct_grey_text mb-0">Company Score</p>
                      </div>
                    </div>
                  </li> */}
                  <li>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-users ct_text_yellow"></i>
                      <div>
                        <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                          {companySize}
                        </h4>
                        <p className="ct_fs_14 ct_grey_text mb-0">Team Size</p>
                      </div>
                    </div>
                  </li>
                  {/* <li>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-briefcase ct_text_yellow"></i>
                      <div>
                        <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                          {profile?.projects_posted || "0"} Projects Posted
                        </h4>
                        <p className="ct_fs_14 ct_grey_text mb-0">Hiring Activity</p>
                      </div>
                    </div>
                  </li> */}
                </ul>
              </div>

              <div className="ct_outline_bg ct_border_radius_10 ct_p_20 ct_mt_40">
                <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                  <p className="ct_fs_16 mb-0 ct_darkblue_text">Company Information</p>
                </div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">Company Name</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">{companyName}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">Industry</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">{profile?.industry || "N/A"}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">Company Size</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">{companySize || "N/A"}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">Website</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {profile?.company_website || "N/A"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">LinkedIn</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {linkedinCompany}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">Country</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {profile?.country || "N/A"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">City</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">{profile?.city || "N/A"}</p>
                  </div>
                </div>
              </div>

              <div className="ct_outline_bg ct_border_radius_10 ct_p_20 ct_mt_40">
                <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                  <p className="ct_fs_16 mb-0 ct_darkblue_text">About Your Company</p>
                </div>
                <p className="ct_fs_14 ct_grey_text mb-0">
                  {companyDescription || "N/A"}
                </p>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="ct_outline_bg ct_border_radius_10 ct_p_20">
                <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                  <p className="ct_fs_16 mb-0 ct_darkblue_text">Contact Persons</p>
                </div>
                <div className="ct_mb_20">
                  <p className="ct_fs_14 ct_grey_text mb-2">Primary Contact</p>
                  <p className="ct_fs_14 ct_darkblue_text mb-1">
                    {primaryContactName} · {primaryContactTitle}
                  </p>
                  <p className="ct_fs_14 ct_grey_text mb-1">
                    {primaryContactEmail}
                  </p>
                  <p className="ct_fs_14 ct_grey_text mb-0">
                    {primaryContactPhone}
                  </p>
                </div>
                <div>
                  <p className="ct_fs_14 ct_grey_text mb-2">Secondary Contact</p>
                  <p className="ct_fs_14 ct_darkblue_text mb-1">
                    {secondaryContactName} · {secondaryContactTitle}
                  </p>
                  <p className="ct_fs_14 ct_grey_text mb-1">
                    {secondaryContactEmail}
                  </p>
                  <p className="ct_fs_14 ct_grey_text mb-0">
                    {secondaryContactPhone}
                  </p>
                </div>
              </div>

              <div className="ct_outline_bg ct_border_radius_10 ct_p_20 ct_mt_40">
                <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                  <p className="ct_fs_16 mb-0 ct_darkblue_text">Hiring Needs</p>
                </div>
                <div className="d-flex flex-column gap-3">
                  <div>
                    <p className="ct_fs_14 ct_grey_text mb-1">Talent Types</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {talentTypes.length ? talentTypes.join(", ") : "N/A"}
                      {profile?.talent_other ? `, ${profile.talent_other}` : ""}
                    </p>
                  </div>
                  <div>
                    <p className="ct_fs_14 ct_grey_text mb-1">Engagement Type</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {engagementTypes.length ? engagementTypes.join(", ") : "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="ct_outline_bg ct_border_radius_10 ct_p_20 ct_mt_40">
                <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                  <p className="ct_fs_16 mb-0 ct_darkblue_text">Work Environment</p>
                </div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">Work Environment</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {workEnvironment}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <p className="ct_fs_14 ct_grey_text mb-0">Preferred Time Zone</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {profile?.preferred_timezone || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="ct_fs_14 ct_grey_text mb-1">Communication Tools</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {communicationTools.length
                        ? communicationTools.join(", ")
                        : "N/A"}
                      {profile?.communication_other
                        ? `, ${profile.communication_other}`
                        : ""}
                    </p>
                  </div>
                  <div>
                    <p className="ct_fs_14 ct_grey_text mb-1">Collaboration Preference</p>
                    <p className="ct_fs_14 ct_darkblue_text mb-0">
                      {profile?.collaboration_type || "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Consent section hidden on profile view */}
            </div>
          </div>
        </div>
      </div>
    </HireTalentLayout>
  );
};

export default Profile;
